export function sort(arr) {
  return {
    by(key) {
      return arr.sort((a, b) => a[key] - b[key]);
    },
  };
}
